
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import ServiceAreaPage from '../pages/service-area/page';
import ContactPage from '../pages/contact/page';
import BlogPage from '../pages/blog/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/service-area',
    element: <ServiceAreaPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
